import { useNavigation } from "@luce/core/adapters/navigation";
import { getErrorMessage } from "@luce/core/apollo";
import { toast } from "@luce/ui";

import { useRedeemGiftCard } from "../gqlhooks/use-redeem-gift-card";

export function useRedeemModal({ onRedeemed }: { onRedeemed: () => void }) {
  const { push } = useNavigation();
  const [redeemGiftCard, { loading }] = useRedeemGiftCard();

  const redeem = async (rawCode: string) => {
    const code = rawCode.trim();
    if (!code) {
      toast.error("Please enter a valid gift card code");
      return;
    }

    try {
      const { data } = await redeemGiftCard({ variables: { input: { code } } });
      const giftCard = data?.redeemGiftCard?.giftCard;
      if (!giftCard) {
        toast.error("Failed to redeem gift card");
        return;
      }

      toast.success("Gift card redeemed successfully!");
      onRedeemed();
      push(`/profile/gift-card/${giftCard.id}`);
    } catch (error) {
      toast.error(getErrorMessage(error, "Failed to redeem gift card"));
    }
  };

  return { redeem, loading };
}
